export default function FullRow(props) {
    const { children } = props;
    return <div className="col-span-12">{children}</div>;
}
